<div class="grid">

    <div class="col-12">
        <p-card header="Artifacts" subheader="" styleClass="ui-card-light" >

            <!--  C R I T E R I A  -->
            <div class="grid">

                <div class="grid col-1 full-width" >

                    <div class="col-2">
                        <label for="dateFrom" class="margin-right">Date From:</label>
                        <p-calendar id="dateFrom" [(ngModel)]="selectedDateFrom" dateFormat="yy-mm-dd" 
                        [showIcon]="true" class="margin-left" (ngModelChange)="onDateChange($event, 'selectedDateFrom')"></p-calendar>
                    </div>
    
                    <div class="col-2">
                        <label for="dateTo" class="margin-left">Date To:</label>
                        <p-calendar id="dateTo" [(ngModel)]="selectedDateTo"  dateFormat="yy-mm-dd" 
                           [showIcon]="true" class="margin-left" (ngModelChange)="onDateChange($event, 'selectedDateTo')"></p-calendar>
                    </div>

                    <div class="col-3">
                        <label for="artifactTypes">Artifact Type:</label>
                      
                        <p-dropdown id ="artifactTypes" [options]="artifactTypes" [(ngModel)]="selectedArtifactType" [filter]="true" 
                            styleClass="prime-dropdown" placeholder="artifact types:" [editable]="false"  class="margin-left" [style]="{'width':'50%'}">
                        </p-dropdown>
                    </div>

    
                    
                    <div class="col-1">
                        <p-button label="Search" styleClass="p-button-success p-button-raised p-button-rounded margin-left" (click)="onSearchClick($event)"></p-button>
                        <!-- <p-button label="Clear" styleClass="p-button-danger p-button-raised p-button-rounded margin-left" (click)="onClearClick($event)"></p-button> -->
                    </div>
    
                    <div class="col-1" id="idSpinner" [hidden]="isSpinnerHidden">
                    <div class="loader"></div>  
                    </div>

                </div>


            </div>  


            <!--  G R I D  -->
            
            <div class="grid">
                <p-table #gridData [columns]="artifactGridCols" [value]="artifacts" selectionMode="single"  class="full-width"
                    styleClass="p-datatable-striped p-datatable-sm"
                     [rowsPerPageOptions]="[10,15,25,50]" [showCurrentPageReport]="true" dataKey="artifactSessionId"
                    sortMode="multiple"  [paginator]="true" [rows]="pageSize">
                    <ng-template pTemplate="caption">
                        Artifacts
                      </ng-template>
                      <ng-template pTemplate="header" let-columns>
                        <tr>
                          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field" *ngIf="col.field !== 'download'"></p-sortIcon>
                          </th>
                        </tr>

                        <tr>
                            <th *ngFor="let col of columns" [ngSwitch]="col.field" [ngStyle]="{'width': col.width, 'display': col.display}">
                                <input *ngSwitchCase="'artifactName'" pInputText type="text" (input)="gridData.filter($any($event.target).value, 'artifactName', 'contains')"  [style]="{'width':'50%'}">
                                <input *ngSwitchCase="'artifactDescription'" pInputText type="text" (input)="gridData.filter($any($event.target).value, 'artifactDescription', 'contains')"  [style]="{'width':'50%'}">
                                <ng-container *ngSwitchCase="'artifactStatus'">
                                    <p-multiSelect
                                      [options]="artifactStatusOptions"
                                      [(ngModel)]="selectedArtifactStatuses"
                                      (onChange)="onArtifactStatusFilterChange()"
                                      optionLabel="label"
                                      optionValue="value"
                                      placeholder="Filter Status"
                                      [style]="{'width': '200px'}">
                                    </p-multiSelect>
                                  </ng-container>
                            </th>
                        </tr>
                      </ng-template>
                      
                      <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pEditableRow]="rowData">
                            <td *ngFor="let col of columns" [ngStyle]="{'width': col.width, 'display': col.display}">
                                <span *ngIf="col.field === 'artifactRequestedTime'">
                                  {{ rowData[col.field] | date: 'yyyy-MM-dd HH:mm:ss' }}
                                </span>
                                <span *ngIf="col.field === 'artifactStatus'">
                                    {{ formatArtifactStatus(rowData[col.field]) }}
                                  </span>
                                <span *ngIf="col.field !== 'artifactStatus' && col.field !== 'artifactRequestedTime'">
                                  {{ rowData[col.field] }}
                                </span>
                                <span *ngIf="col.field === 'download' && rowData.artifactStatus === 'ARTIFACT_DELIVERED'" style="text-align:center">
                                    <button  pButton type="button" icon="pi pi-download" [style]="{'width':'20px', 'height':'20px', 'margin-right':'2px'}"  
                                        data-toggle="tooltip" data-placement="top" title="Download previously generated artifact" 
                                        class="ui-button-info" (click)="onFileDownload(rowData)">
                                    </button>
                                </span>
                            </td>
                            
                        </tr>
                      </ng-template> 
                    <!-- Empty Message Template -->
                    <ng-template pTemplate="emptymessage">
                        <tr>
                        <td [attr.colspan]="artifactGridCols.length + 1" style="text-align: center;">
                            <strong>No data found</strong>
                        </td>
                        </tr>
                    </ng-template>

                </p-table> 

            </div>

           
        </p-card>
    </div>            

</div>    


<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="my-generated-artifacts"></p-confirmDialog>